import React, { useContext } from 'react';
import LoadingIcon from '../../components/loading/loading-icon';
import InfiniteScroll from 'react-infinite-scroller';
import PostRow from '../../components/posts/post-row';
import PostItem from '../../components/posts/post-item';

import { PostsListContext } from '../../../context/posts-list-provider';

import './posts-list-style.css';

function PostsList() {
  const [provider] = useContext(PostsListContext);

  function loadMore(pn) {
    provider.loadPosts('all', pn);
  }

  let i_s_setting = {
    pageStart: provider.pageNumber,
    loadMore: loadMore,
    hasMore: provider.hasMore,
    useWindow: true,
    loader: <LoadingIcon className={'post-loading'} width={32} height={32} fill={'#555555'} key={0} />,
  };

  if (provider.postLoaded) {
    return (
      <div className="posts-list">
        <article className="f-grow-1">
          <InfiniteScroll {...i_s_setting}>
            {provider.posts.map((row, i) => {
              return (
                <PostRow key={i}>
                  {row.map((post) => {
                    return <PostItem data={post} key={post.id} />;
                  })}
                </PostRow>
              );
            })}
          </InfiniteScroll>
        </article>
      </div>
    );
  } else {
    return (
      <div className="posts-list">
        <LoadingIcon className={'post-loading'} width={32} height={32} fill={'#555555'} key={0} />
      </div>
    );
  }
}

export default PostsList;
